module.exports = __webpack_public_path__ + "img/photo-42.c7cae07b.webp";